<section data-test="task-item">
	<div class="top">
		<div class="title" [attr.data-test]="task.code + '-task'">
			@if (task.completed) {
				<div class="completed">
					@if (task.executed) {
						<i class="fa fa-check"></i>
					}
					@if (!task.executed) {
						<i class="fa fa-minus executed"></i>
					}
					@if (task.important) {
						<i class="important fa fa-flag"></i>
					}
				</div>
			}
			<div>
				{{ task.name | language }}
				@if (task.recordType === "WOUNDCARE") {
					<span>- {{ "wound_care.body." + task.woundCare?.bodyPart | translate }} </span>
				}
				@if (task.index && !task.unplanned) {
					<span>({{ task.index }})</span>
				}
			</div>
		</div>
		@if (!task.unplanned && shiftId !== task.shift) {
			<div class="shift" data-test="previous-shift-task-indicator">
				{{ "tasks.previous" | translate }}
			</div>
		}
		@if (task.unplanned) {
			<div class="status" data-test="unplanned-task-indicator">
				{{ "tasks.task_unplanned" | translate }}
			</div>
		}
		@if (!task.completed && (!task.hasUserHandlePermission || isDisabled)) {
			<div>
				<i class="fa fa-lock fa-lg"></i>
			</div>
		}
	</div>
	<small class="muted-footer">
		@if (!task.completed) {
			<individual-plan [plan]="task.individualPlan" />
		} @else {
			{{ task.user?.firstName + " " + task.user?.name }} - {{ task?.date | elapsed }}
		}
	</small>
</section>
